import getDataValueCustomerInfoLoyaltySelect from 'modules/loyalty/redux/selectors/get-data-value-customer-info'
import { LOYALTY_DATA_KEY } from 'modules/loyalty/constants'

const getFastTrackExtensionExpirationDateLoyaltySelect = state => {
  const str = getDataValueCustomerInfoLoyaltySelect(LOYALTY_DATA_KEY.fast_track_extension_expiration_date)(state)
  if (!str) {
    return
  }
  return new Date(str)
}

export default getFastTrackExtensionExpirationDateLoyaltySelect
